module.exports = __webpack_public_path__ + "static/media/ai-banner-campaign.664f1e34.png";